<script lang="ts">
	import { CUSTOM_SHOWS_LINK, Guides } from "luxedo-data"
	import { Responsive } from "responsive"

	let isMobile = $derived(Responsive.isMobile)
</script>

<div class="content-solutions" class:isMobile>
	<h1>Looking for easy content solutions?</h1>
	<p>
		If you require content that is not available in our library, here are a few resources we
		recommend for quality content.
	</p>
	<h2>LuxStudio</h2>
	<p>
		Design personalized projection shows in minutes using <strong>LuxStudio</strong> — our automated
		show creation tool powered by AI. Choose from curated themes and generate a ready-to-play show tailored
		to your space.
	</p>

	<h2>Luxedo Custom Shows</h2>
	<p>
		Work directly with our in-house content team to create a show tailored to your projection space,
		calibrated device, and theme.
	</p>
	<p class="muted">
		After checkout, we'll email you within <strong>24 business hours</strong> to request your device
		snapshot and resolution so we can get started.
		<br />
		<a
			class="btn"
			target="_blank"
			rel="noopener noreferrer"
			href={CUSTOM_SHOWS_LINK}
		>
			Browse Custom Shows
		</a>
	</p>

	<br />
	<p>Prefer to work with a partner? These providers can also build a custom show for you:</p>
	<div class="link-list">
		<a target="_blank" href="https://www.jollyholidayshows.com/">Jolly Holiday Shows</a>
		<a target="_blank" href="https://www.jesterlaughs.com/">Jester Laughs</a>
		<a target="_blank" href="https://holidayprojectionmapping.com/">Holiday Projection Mapping</a>
	</div>
	<h2>Media solutions</h2>
	<p>
		Enhance your media library with free assets. Download to your desktop, then
		<a
			target="_blank"
			rel="noopener noreferrer"
			href={Guides.default["Luxedo Portal"]["Uploading Media"]}
		>
			upload them to your Luxedo library
		</a>.
	</p>
	<div class="link-list">
		<a target="_blank" href="https://pngimg.com/">pngimg.com</a>
		<a target="_blank" href="https://pixabay.com/">pixabay.com</a>
		<a target="_blank" href="https://favpng.com/">favpng.com</a>
	</div>
	<br />
	<p>Looking for premium scene videos? We recommend AtmosFX (paid)</p>
	<div class="link-list">
		<a
			href="https://atmosfx.com/?rfsn=6031736.5d6d01&amp;utm_source=refersion&amp;utm_medium=affiliate&amp;utm_campaign=6031736.5d6d01"
			>atmosfx.com</a
		>
	</div>
</div>

<style>
	h1 {
		font-size: var(--text-h3);
		color: var(--color-main);
		margin-top: 2rem;
		margin-bottom: 0.5rem;
		/* margin: 0; */
	}

	h2 {
		font-size: var(--text-h4);
		color: var(--color-main);
		margin: 1rem 0 0.5rem 0;
	}

	p {
		color: var(--color-text);
		margin: 0;
		line-height: 1.4;
	}

	.link-list a {
		margin-right: 1rem;
	}

	a {
		color: var(--color-text-light);
		border-color: var(--color-text-light);
	}

	a:hover,
	a:focus-visible {
		color: var(--color-main);
		border-color: var(--color-main);
	}

	.content-solutions {
		overflow-y: auto;
	}

	.isMobile h1 {
		margin-top: 0;
		line-height: 1.25;
	}
</style>
